// extracted by mini-css-extract-plugin
export default {"mCard":"Xx-z","image":"Yx-z","imageNoBackground":"Zx-z","imageHasCategory":"_x-z","fullWidth":"ay-z"};